import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import {
  AlertAuraComponent,
  AuraColorType,
  ButtonCardComponent,
  DialogLayoutAuraComponent,
} from '@workspace/ng-aura';

export interface PropertyDpeAutocompleteDialogData {
  currentAddress: string;
  ademeAddress: string;
  ademeNumber: string;
}

@Component({
  selector: 'etxe-property-dpe-autocomplete-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    DialogLayoutAuraComponent,
    AlertAuraComponent,
    ButtonCardComponent,
  ],
  templateUrl: './dpe-autocomplete-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyDpeAutocompleteDialogComponent {
  readonly ref = inject(MatDialogRef<PropertyDpeAutocompleteDialogComponent>);
  readonly data = inject<PropertyDpeAutocompleteDialogData>(MAT_DIALOG_DATA);

  userChoice = signal<'confirm' | 'cancel' | null>(null);
  auraColorType = AuraColorType;

  readonly alertConfig = {
    type: AuraColorType.INFO,
    message:
      "L'adresse associée à ce DPE semble différente de celle de votre annonce. Cela peut arriver, vérifiez une dernière fois avant de continuer.",
  };

  onSelect(choice: 'confirm' | 'cancel') {
    this.userChoice.set(choice);
  }

  confirm() {
    this.ref.close(this.userChoice());
  }
}
